/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTimeUpdateQueryResult } from '../../models/get-project-time-update-query-result';

export interface ApiProjectTimeUpdateGetTimeUpdateGet$Params {
  Id: string;
}

export function apiProjectTimeUpdateGetTimeUpdateGet(http: HttpClient, rootUrl: string, params: ApiProjectTimeUpdateGetTimeUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTimeUpdateQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTimeUpdateGetTimeUpdateGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTimeUpdateQueryResult>;
    })
  );
}

apiProjectTimeUpdateGetTimeUpdateGet.PATH = '/api/ProjectTimeUpdate/GetTimeUpdate';
